export default __webpack_public_path__ + "static/media/truck.61e3a3ed.jpg";